<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.mini_game") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    span {{ $t('ui.status') }}
                  b-form-select(v-model="isEnable" :disabled="loading" size="sm")
                    option(:value="null") {{ $t('ui.all') }}
                    option(:value="true") {{ $t('ui.enabled') }}
                    option(:value="false") {{ $t('ui.disabled') }}
              .form-group.col-3
                b-input-group(size="sm")
                  b-input-group-text(slot="prepend")
                    i.fa.fa-search
                  DebounceInput(autofocus type="text" v-model="gameName" :disabled="loading" :placeholder="$t('message.search_by_game_name')" @enter="getMiniGameList(true)" size="sm")

              .form-group.col-6.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-search"
                  :text="$t('ui.search')"
                  type="button"
                  @click="getMiniGameList(true)"
                  variant="primary"
                  size="sm"
                )
              .form-group.col-12(v-if="isAdmin && isEditAccess")
                b-button(v-b-modal.addMiniGame type="button" variant="info" size="sm")
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_mini_game") }}
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="8%")
                          span(:title="$t('ui.game_type')") {{ $t('ui.game_type') }}
                        th(width="10%")
                          span(:title="$t('ui.game_name')") {{ $t('ui.game_name') }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.token_request')") {{ $t('ui.token_request') }}
                        th.text-center(width="10%")
                          span(:title="$t('ui.max_game_reward')") {{ $t('ui.max_game_reward') }}
                        th.text-center(width="10%")
                          span(:title="$t('ui.max_chance_per_day')") {{ $t('ui.max_chance_per_day') }}
                        th.text-center(width="6%")
                          span(:title="$t('ui.is_recurring_chance')") {{ $t('ui.is_recurring_chance') }}
                        th.text-center(width="6%")
                          span(:title="$t('ui.status')") {{ $t('ui.status') }}
                        th.text-right(width="10%")
                          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                        th.text-center(width="5%")
                          span(:title="$t('ui.action')") {{ $t('ui.action') }}
                    tbody.clusterize-content
                      tr(v-if="miniGameList.length == 0")
                        td(colspan="10").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in miniGameList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.game_type.toUpperCase()") {{ item.game_type.toUpperCase() }}
                        td
                          span(:title="item.game_name") {{ item.game_name }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(item.token_request)" :title="item.token_request") {{ item.token_request }}
                        td.text-center.font-weight-bold
                          span(:title="item.max_game_reward") {{ item.max_game_reward }}
                        td.text-center.font-weight-bold
                          template(v-if="item.max_chance_per_day != null")
                            span(:title="item.max_chance_per_day") {{ item.max_chance_per_day }}
                          template(v-else)
                            span(:title="$t('ui.unlimited')") {{ $t('ui.unlimited')}}
                        td.text-center
                          span
                            i(style="font-size: 14px;" :class="{'fas fa-check-circle text-success': item.is_recurring_chance, 'fas fa-times-circle text-warning': !item.is_recurring_chance  }")
                        td.text-center
                          span
                            i(style="font-size: 14px;" :class="{'fas fa-check-circle text-success': item.status, 'fas fa-times-circle text-warning': !item.status  }")
                        td.text-right
                          span(:title="item.created_by") {{ item.created_by }}
                          br
                          span(:title="$moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.actions.text-center.align-middle
                          span.mr-2
                            a.fas.fa-clipboard-list.btn.btn-ssm.btn-icon.btn-info(
                              v-if="isAdmin"
                              href="javascript:void(0)"
                              @click="showMiniGameTemplate(item)"
                              :title="$t('ui.mini_game_template')"
                              )
                          span.mr-2
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                              v-if="isAdmin && isEditAccess"
                              href="javascript:void(0)"
                              @click="onEdit(item)"
                              :title="$t('ui.edit')"
                              )
                          //- span
                          //-   a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(
                          //-     v-if="isAdmin && isEditAccess"
                          //-     href="javascript:void(0)"
                          //-     @click="onDelete(item)"
                          //-     :title="$t('ui.delete')"
                          //-     )

      addminigame(@clicked="addMiniGame" @failed="handleFailed")
      editminigame(ref="editminigame" :item="editSelectedMiniGame" @clicked="afterEdit" @failed="handleFailed")
      minigametemplate(ref="minigametemplate" :item="editSelectedMiniGame")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import addminigame from "@/components/content/miniGame/addMiniGame.vue";
import editminigame from "@/components/content/miniGame/editMiniGame.vue";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import minigametemplate from "@/components/content/miniGame/miniGameTemplate.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    addminigame,
    editminigame,
    minigametemplate
  },
  data: () => ({
    loading: false,
    editSelectedMiniGame: null,
    miniGameList: [],
    isEnable: null,
    gameName: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_minigame");
    }
  },
  mounted: function() {
    this.getMiniGameList(true);
  },
  methods: {
    showMiniGameTemplate(e) {
      this.editSelectedMiniGame = e;
      this.$refs.minigametemplate.$refs.miniGameTemplate.show();
    },
    onEdit(e) {
      this.editSelectedMiniGame = e;
      this.$refs.editminigame.$refs.editMiniGame.show();
    },
    afterEdit() {
      this.getMiniGameList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_mini_game"), this.$t("message.success"), "success");
    },
    // onDelete:function(e) {
    //   this.$helpers
    //     .alert({
    //       title: this.$t("ui.delete"),
    //       text: this.$t("message.delete_mini_game_confirm", { minigame: e.game_name }),
    //       type: "question",
    //       showCancelButton: true
    //     })
    //     .then(result => {
    //       if (result.value) {
    //         this.confirmDelete(e);
    //       }
    //     });
    // },
    // confirmDelete: function(e) {
    //   let url = config.deleteMiniGameUrl();

    //   var json = {
    //     auth_token: this.$store.getters.sessionToken,
    //     action_by: this.$store.getters.loginId,
    //     game_id: e.game_id,
    //   };

    //   this.feedback.success = true;
    //   this.loading = true;
    //   this.$http.post(url, json).then(
    //     function(response) {
    //       this.loading = false;
    //       // Success
    //       try {
    //         if (response) {
    //           if (typeof response.data.status == "string") {
    //             this.feedback.success = response.data.status == "1";
    //           } else {
    //             this.feedback.success = response.data.status == 1;
    //           }
    //           this.feedback.status = response.data.statusdesc;
    //           if (this.feedback.success == true) {
    //             this.getMiniGameList(true);
    //             this.$helpers.showDialog(this.$t("ui.delete"), this.$t("message.success"), "success");
    //           } else {
    //             if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //           }
    //         }
    //       } catch (error) {
    //         this.feedback.success = false;
    //         this.feedback.status = errorTags.request.failed;
    //         this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //       }
    //     },
    //     function(response) {
    //       this.loading = false;
    //       // Error
    //       this.feedback.success = false;
    //       this.feedback.status = errorTags.request.failed;
    //       this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //     }
    //   );
    // },
    getMiniGameList: function() {
      let url = config.getMiniGameListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        game_name: this.gameName,
        enable: this.isEnable,
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.miniGameList = response.data.dt;
                this.totalRow = this.miniGameList.length > 0 ? this.miniGameList[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },

    addMiniGame: function() {
      this.getMiniGameList(true);
      this.$helpers.showDialog(this.$t("ui.combine.add_mini_game"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>